
var $ = jQuery.noConflict();

$(function() {

  $('.js-modalVimeo').on('shown.bs.modal', function(e) {
    var autoPlay = $('.b-Modal__body iframe', this).attr('src') + '&autoplay=1';
    $('.b-Modal__body iframe', this).attr('src', autoPlay);
  });

  $('.js-modalVimeo').on('hide.bs.modal', function(e) {
    var src =  $('.b-Modal__body iframe', this).attr('src').replace('&autoplay=1', '');
    $('.b-Modal__body iframe', this).attr('src', src);
  });

});